import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "../../lib/utils";

export function Tabs({ className, ...props }) {
  return <TabsPrimitive.Root className={cn("", className)} {...props} />;
}

export function TabsList({ className, ...props }) {
  return (
    <TabsPrimitive.List
      className={cn(
        "inline-flex w-full items-center rounded-full bg-[var(--surface)] border border-[var(--border-ui)] p-1 gap-1",
        className
      )}
      {...props}
    />
  );
}

export function TabsTrigger({ className, ...props }) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        "flex-1 inline-flex items-center justify-center gap-2.5 rounded-lg px-4 py-2.5 text-[13px] font-medium transition-all duration-150 cursor-pointer",
        "text-[var(--muted-text)] hover:text-[var(--text-soft)]",
        "data-[state=active]:bg-[#60a5fa]/[0.16] data-[state=active]:text-[#3b82f6]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#60a5fa]/40",
        className
      )}
      {...props}
    />
  );
}

export function TabsContent({ className, ...props }) {
  return (
    <TabsPrimitive.Content
      className={cn("", className)}
      {...props}
    />
  );
}
